import React from 'react';
import properties from '../../constants/Properties';
import { ColorPicker } from './ColorPicker';
import { changeTextProperties, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import storeManager from '../../store/StoreManager';
import { FontsSelector } from '../../components/menus/FontsSelector';
import {changeContextMode, expandFontsList} from '../../actions/MenuActions';
import locales from '../../locales/LocalesManager';
import textSizeUtils from '../utils/TextSizeUtils';
import platformDetection from '../utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import appParameters from '../utils/AppParameters';
import modeType from '../../constants/ModeConstants';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        var closeButtonStyle = {
            position: 'absolute',
            right: 28,
            top: 4,
            width: 22,
            height: 22,
            cursor: 'pointer',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            background: 'none',
            borderStyle: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            right: 3,
            cursor: 'pointer'
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('TextStylingMenuTitle', 'textStylingMenu')}</span>

                <button id="firstFocusableObjectForTextStylingMenu" style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const shapeModel = this.getCurrentTarget();
        var propertyType;
        var newValue;

        if (!shapeModel)
            return;

        switch (this.props.index) {
            case 0: {
                propertyType = 'fontBold';
                newValue = !shapeModel.fontBold;
                break;
            }

            case 1: {
                propertyType = 'fontItalic';
                newValue = !shapeModel.fontItalic;
                break;
            }

            case 2: {
                propertyType = 'fontUnderline';
                newValue = !shapeModel.fontUnderline;
                break;
            }

            case 3: {
                propertyType = 'fontAlign';
                newValue = 'left';
                break;
            }

            case 4: {
                propertyType = 'fontAlign';
                newValue = 'center';
                break;
            }

            case 5: {
                propertyType = 'fontAlign';
                newValue = 'right';
                break;
            }
        }

        this.props.dispatch(changeTextProperties(shapeModel, propertyType, newValue));
        audioEditorUtils.addActionToHistory();
        this.updateThumbnail();
        saveManager.isContentChanged(true);

        setTimeout(this.checkSize, 50);
    },
    updateThumbnail() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    checkSize() {
        const { dispatch } = this.props;
        const shapeModel = this.getCurrentTarget();

        textSizeUtils.updateTextWrapperSize(shapeModel, dispatch);
    },
    isSelected() {
        const shapeModel = this.getCurrentTarget();
        var isSelected = false;

        if (!shapeModel)
            return;

       switch (this.props.index) {
           case 0: { // Bold
               if (shapeModel.fontBold == true)
                  isSelected = true;
               break;
           }
           case 1: { // Italic
               if (shapeModel.fontItalic == true)
                   isSelected = true;
               break;
           }
           case 2: { // Underline
               if (shapeModel.fontUnderline == true)
                   isSelected = true;
               break;
           }
           case 3:
           case 4:
           case 5: { // Align
               if (shapeModel.fontAlign == undefined && this.props.index == 3)
                    isSelected = true;
               else {
                   if (this.props.index == 3 && shapeModel.fontAlign == 'left')
                        isSelected = true;
                   else if (this.props.index == 4 && shapeModel.fontAlign == 'center')
                       isSelected = true;
                   else if (this.props.index == 5 && shapeModel.fontAlign == 'right')
                       isSelected = true;
               }
               break;
           }
       }

        return isSelected;
    },
    getCurrentTarget () {
        const state = storeManager.getState();
        const uuid = this.props.shapeModel.uuid;
        const shapes = state.currentSlide.model.content;
        var i;
        var target;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].uuid == uuid) {
                target = shapes[i];
                break;
            }
        }

        return target;
    },
    render() {
        var iconColor;
        var buttonColor;

        if (this.isSelected() == true) {
            iconColor = 'white';
            buttonColor = properties.BROWSER_SELECTED_COLOR;
        } else {
            if (this.state.isOver == true) {
                iconColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                iconColor = 'black';
                buttonColor = properties.SLIDE_MENU_COLOR;
            }
        }

        var buttonWidth = (this.props.accordionWidth - 2 * properties.STYLING_LEFT_GAP) / 3;
        var index = this.props.index > 2 ? (this.props.index - 3) : this.props.index;
        var left = properties.STYLING_LEFT_GAP + index * buttonWidth;

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: buttonWidth,
            height: properties.TEXT_STYLING_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            left: left,
            top: 0,
            color: 'white',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'black',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial'
        };

        const cornerRadius = 8;

        if (this.props.index == 0 || this.props.index == 3) {
            buttonStyle.borderTopLeftRadius = cornerRadius;
            buttonStyle.borderBottomLeftRadius = cornerRadius;
        } else if (this.props.index == 2 || this.props.index == 5) {
            buttonStyle.borderTopRightRadius = cornerRadius;
            buttonStyle.borderBottomRightRadius = cornerRadius;
        }

        var iconStyle = {
            position: 'absolute',
            top: 9,
            left: 40,
            color: iconColor
        };

        var icon = this.props.icon;

        if (platformDetection.isIOS() == true) {
            iconStyle.left = 25;
        }

        var ariaLabel;

        switch (this.props.index) {
            case 0: { // Bold
                ariaLabel = locales.getCaption('bold', 'other');
                break;
            }
            case 1: { // Italic
                ariaLabel = locales.getCaption('italic', 'other');
                break;
            }
            case 2: { // Underline
                ariaLabel = locales.getCaption('underline', 'other');
                break;
            }
            case 3: { // Left
                ariaLabel = locales.getCaption('leftAlignment', 'other');
                break;
            }
            case 4: { // Center
                ariaLabel = locales.getCaption('centerAlignment', 'other');
                break;
            }
            case 5: { // Right
                ariaLabel = locales.getCaption('rightAlignment', 'other');
                break;
            }
        }

        return (
            <button aria-label={ariaLabel} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <i style={iconStyle} className={icon}></i>
            </button>
        );
    }
});

export const TextStylingMenu = React.createClass({
    componentDidMount() {
        document.addEventListener('keydown', this.onKeyDownHandler);
    },
    onKeyDownHandler(e) {
        if (platformDetection.isIOS())
            return;

        var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

        if (!isTabPressed)
            return;

        setTimeout(function() {
            if (document.activeElement.id.indexOf('shapeMenuButton') != -1)
                return;

            if (!this.hasParentWithId(document.activeElement, 'textStylingMenu', 8)) {
                var element = document.getElementById('firstFocusableObjectForTextStylingMenu');

                if (element)
                    element.focus();
            }
        }.bind(this), 20);
    },
    hasParentWithId(target, parentId, level) {
        if (target.id == parentId)
            return true;

        var i;

        for (i=0; i<level; i++) {
            if (target.parentNode == undefined) {
                return false;
            } else {
                target = target.parentNode;

                if (target.id == parentId)
                    return true;
            }
        }

        return false;
    },
    refreshView() {
        this.forceUpdate();
    },
    isBackgroundVisible () {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var target;
        var i;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].uuid == this.props.shapeModel.uuid) {
                target = shapes[i];
                break;
            }

        if (target.backgroundVisible == false)
            return false;
        else
            return true;
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const target = e.target;
        if (!(this.hasParentWithId(target, 'fontsMenu', 6) == true || target.parentNode.className =='scrollComponent' || target.parentNode.parentNode.className =='scrollComponent'))
            this.props.dispatch(expandFontsList(false));

        this.forceUpdate();
    },
    hasParentWithId(target, parentId, level) {
        if (target.id == parentId)
            return true;

        var i;

        for (i=0; i<level; i++) {
            if (target.parentNode == undefined) {
                return false;
            } else {
                target = target.parentNode;

                if (target.id == parentId)
                    return true;
            }
        }

        return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.contextTarget != newProps.contextTarget || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var topPosition = properties.CLIPART_BUTTON_HEIGHT + 2 * properties.STYLING_TOP_GAP + properties.EFFECTS_BUTTON_HEIGHT;

        const fontStyle = {
            position: 'absolute',
            top: topPosition
        };

        topPosition = topPosition + properties.TEXT_STYLING_BUTTON_HEIGHT + properties.STYLING_TOP_GAP;

        const alignStyle = {
            position: 'absolute',
            top: topPosition
        };

        topPosition = topPosition + properties.TEXT_STYLING_BUTTON_HEIGHT + properties.STYLING_TOP_GAP;

        const colorPickerTopPosition = topPosition;

        var leftPosition = 0;

        if (this.props.accordionWidth > properties.BROWSER_WIDTH)
            leftPosition = (this.props.accordionWidth - properties.BROWSER_WIDTH) / 2;

        const elementsHolder = {
            position: 'absolute',
            top: 0,
            left: leftPosition,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            cursor: 'default',
            overflowX: 'auto'
        };

        return (
            <div id="textStylingMenu" style={menuStyle} onTouchStart={this.onClick} onMouseDown={this.onClick}>
                <Title accordionWidth={this.props.accordionWidth}/>
                <div style={elementsHolder}>
                    <FontsSelector accordionWidth={properties.BROWSER_WIDTH} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} top={properties.CLIPART_BUTTON_HEIGHT + properties.STYLING_TOP_GAP}/>

                    <div style={fontStyle} onClick={this.refreshView}>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={0} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} icon='fa fa-bold'/>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={1} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} icon='fa fa-italic'/>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={2} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} icon='fa fa-underline'/>
                    </div>

                    <div style={alignStyle} onClick={this.refreshView}>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={3} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} icon='fa fa-align-left'/>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={4} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} icon='fa fa-align-center'/>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={5} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} icon='fa fa-align-right'/>
                    </div>

                    <ColorPicker id="textStylingMenuLastFocusableElement" accordionWidth={properties.BROWSER_WIDTH} tab={this.props.tab} topPosition={colorPickerTopPosition} shapeModel={this.props.contextTarget} dispatch={this.props.dispatch} type='textProperties'/>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/TextStylingMenu.js
 **/